<div class="inbox-container">

  <!-- Header -->
  <!-- <div class="inbox-header">
    <h2 class="inbox-title">
      <span class="unread-chip" *ngIf="unreadCount > 0">{{ unreadCount }} ungelesen</span>
    </h2>
  </div> -->

  <!-- Loading -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && notifications.length === 0" class="empty-state">
    <mat-icon class="empty-icon">notifications_none</mat-icon>
    <p>Keine Benachrichtigungen vorhanden</p>
  </div>

  <!-- Notification list -->
  <mat-list *ngIf="!isLoading && notifications.length > 0" class="notification-list">
    <mat-list-item
      *ngFor="let notification of notifications"
      class="notification-item"
      [class.unread]="!notification.read"
      (click)="openNotification(notification)"
    >
      <div class="item-content">
        <div class="item-left">
          <span class="unread-dot" *ngIf="!notification.read"></span>
          <mat-icon class="item-icon" [class.icon-unread]="!notification.read">mail_outline</mat-icon>
        </div>
        <div class="item-body">
          <div class="item-title" [class.bold]="!notification.read">{{ notification.title }}</div>
          <div class="item-preview">{{ notification.body }}</div>
          <div class="item-time">{{ formatTimestamp(notification) }}</div>
        </div>
      </div>
    </mat-list-item>
  </mat-list>

  <!-- Detail overlay -->
  <div class="detail-overlay" *ngIf="selectedNotification || isLoadingDetail" (click)="closeDetail()">
    <mat-card class="detail-card" (click)="$event.stopPropagation()">

      <div *ngIf="isLoadingDetail && !selectedNotification" class="detail-loading">
        <mat-spinner diameter="36"></mat-spinner>
        <p class="detail-loading-id">{{ pendingIdDisplay }}</p>
      </div>

      <ng-container *ngIf="selectedNotification">
        <div class="detail-modern-header">
          <mat-icon class="detail-modern-icon">mail_outline</mat-icon>
          <div class="detail-modern-titles">
            <div class="detail-modern-title">{{ selectedNotification.title }}</div>
            <div class="detail-modern-time">{{ formatTimestamp(selectedNotification) }}</div>
          </div>
          <button mat-icon-button class="detail-close-btn" (click)="closeDetail()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <mat-divider></mat-divider>
        <mat-card-content class="detail-modern-content">
          <p class="detail-body">{{ selectedNotification.messageBody || selectedNotification.body }}</p>
        </mat-card-content>
        <mat-divider></mat-divider>
        <div class="detail-modern-actions">
          <button mat-button class="action-btn action-unread" (click)="markSelectedUnread()">
            <mat-icon>mark_email_unread</mat-icon>
            Als ungelesen markieren
          </button>
          <button mat-button class="action-btn action-delete" (click)="deleteSelected()">
            <mat-icon>delete_outline</mat-icon>
            Löschen
          </button>
        </div>
      </ng-container>

    </mat-card>
  </div>

</div>
